<template>
    <div>
        <userCard></userCard>
        <div class="list-container">
            <a class="item" href="https://saint-gobain-tool.cloud.pageseagle.com/#/">
                <img src="https://oss.cloud.custouch.com/res/56259/会员中心-工业流体选型工具.png" alt />
            </a>
            <a class="item" href="https://720yun.com/t/39vkOwdqz1b#scene_id=54599150">
                <img src="https://oss.cloud.custouch.com/res/75550/会员中心-百宝箱-软管博物馆2.png" alt />
            </a>
        </div>
    </div>
</template>

<script >
import userCard from './components/userCard'
export default {
    components: {
        userCard
    },
    methods: {
    }
}
</script>
<style scoped lang="less">
.list-container {
    padding: 1.4rem 1rem;
    display: grid;
    grid-template-columns: repeat(4,4.3rem);
    grid-gap:1rem;
    .item {
        img{

            width: 100%;
            height: auto;
        }
    }
}
</style>
